import { Box, CircularProgress, Divider, Grid, Hidden, IconButton, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { InvestmentFundType } from '../../../../redux-store/types/api-types';
import { FormikProps, FormikValues, useFormikContext } from 'formik';
import { MandateCreation } from '../../../../redux-store/types/investorProfile';
import { MpowerValidationType, SwitchNavigationProps } from '../../types';
import { checkImageExists, formatCurrency } from '../../../../utils/utilityFunctions';
import { BlueEditIcon, CheckIcon, DeleteIcons, InfoIconOutlined, UnCheckIcon } from '../../../../assets/SvgIcons';
import { CustomeBlueDropDown, CustomeNumberInput, FormCheckBox } from '../../transcation/FromInput';
import HoldingModal from '../common/HoldingModal'
import { setSelectedAllHoldingsInfo, setSelectedHoldingsInfo } from '../../../../redux-store/actions/investorProfile';
import { ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MPOWER_ACCOUNT_TYPE_MASTER,REDEEM_TO_DEFAULT_ACCOUNT, USER_ROLES } from '../../../../utils/constant';
import { useHistory } from 'react-router';


interface CardProps {
    isLoading: boolean,
    data?: InvestmentFundType,
    clientCode: string
    itemData: { units: number, folioNo: string | number, navDate: string, navValue: number, balanceAmount: number, availableUnits: number }
    bankList: Array<MandateCreation> | undefined
    navState: any
    isSubmitting: boolean;
    id: string | number;
    folio: { folioId: string, schemeId: string, marketValue: string, investedValue: string, id: string };
    handleDelete: (checkId: string, selectedUniqueId: string) => void,
}

function Card(props: CardProps): JSX.Element {
    const dispatch = useDispatch()
    const history = useHistory();

    const { isLoading, data, clientCode, itemData, bankList = [], navState, isSubmitting, id, folio, handleDelete } = props;
    const { palette, typography } = useTheme()
    const { errors = {}, values, setFieldValue, resetForm, validateField } = useFormikContext() as FormikProps<FormikValues>

    const {
        locale,
        currencyCode,
        currencySymbol
    } = useSelector((store: RootStateType) => store.currencyInfo);
    const {
        selectAllHoldingsInfo,
        selectedHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);

    const {
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const {
        role = '',
    } = useSelector((store: RootStateType) => store.auth);

    const filterValidation = values?.fund?.[id]?.investmentDetails?.validations?.find((item: MpowerValidationType) => item?.transactionType === 'RED')

    const handleDeleteCardValue = (scheme: string, selectedUniqueId: string) => {
        // const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ checkedId }) => checkedId !== scheme)
        // const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id: checkedId }) => checkedId !== scheme)

        const modifiedSelectedHoldingsInfo = selectedHoldingsInfo.filter(({ uniqueId }) => uniqueId !== selectedUniqueId)
        const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ uniqueId }) => uniqueId !== selectedUniqueId)

        dispatch(setSelectedHoldingsInfo([...modifiedSelectedHoldingsInfo]))
        dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))

        history.replace({
            state: ({
                selectedSchemes: [...modifiedSelectedAllHoldingsInfo],
                clientCode,
                schemeDetails: modifiedSelectedAllHoldingsInfo?.map((obj) => ({
                    scheme_id: obj?.schemeId ?? "-",
                    isReinvestment: obj?.isReinvest ?? "-"
                })),
                folio: [...modifiedSelectedHoldingsInfo],
            })
        })

        const newValues = (values.fund ?? []).filter((item: any) => {
            // return item?.folio?.id !== scheme
            return (item?.selectedSchemeDetails?.uniqueId !== selectedUniqueId)
        })

        resetForm({
            values: {
                fund: newValues,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: values?.documents ?? []
                } : {})
            }
        })

        handleDelete(scheme, selectedUniqueId)
    }

    const amcIds = ['BDOTR', 'BPIAMC']
    const checkAmcId = amcIds.includes(data?.fundAmcId ?? '') ? data?.fundAmcId?.toLowerCase() : data?.fundAmcId;

    return (
        <Box sx={{ background: palette.background.paper, boxShadow: 1, borderRadius: '20px', padding: '35px 30px', display: 'flex', flexDirection: 'column', gap: '35px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '15px', width: '85%' }}>
                    {isLoading ? <CircularProgress /> :
                        <img src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`} width={'50px'} height={'50px'} alt="Bank name" style={{ borderRadius: '8px 8px 8px 8px' }} />
                    }
                    <Box>
                        <Typography variant='body_600'
                            color="text.primary"
                            fontSize={{ xs: '14px', sm: '16px', md: '16px', lg: '18px' }}
                            sx={{
                                maxWidth: '100%',
                            }}>
                            {/* {navState?.itemData?.schemeName || ''} */}
                            {data?.fundName ?? ""}
                        </Typography>

                        <Box display={'flex'} flexDirection={'row'} gap={'5px'}>
                            <Typography variant='body_500' color={palette.text.secondary} sx={{
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                maxWidth: '100%',
                            }}>
                                {/* {navState?.itemData?.categoryName || ''} */}
                                {data?.fundType ?? ""}
                            </Typography>
                            <Typography variant='body_500' color={palette.text.secondary} sx={{
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                maxWidth: '100%',
                            }}>•
                                {/* {navState?.itemData?.subCategoryName || ''} */}
                                {data?.fundCap ?? ""}
                            </Typography>
                            {/* {navState?.itemData?.riskType !== "NULL" || navState?.itemData?.riskType &&
                                <Typography variant='body_500' color={palette.success[500]} sx={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: '100%',
                                }}>• {navState?.itemData?.riskType || ''}</Typography>
                            } */}
                            {(
                                `${data?.riskType ?? ""}`.toLowerCase() !== "null" || data?.riskType
                            ) &&
                                <Typography variant='body_500' color={palette.success[500]} sx={{
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    maxWidth: '100%',
                                }}>
                                    • {data?.riskType ?? ''}
                                </Typography>
                            }
                        </Box>
                        <Box sx={{ marginTop: "3px" }}>
                            <Typography
                                variant="body_500"
                                color="text.primary"
                            >
                                ISIN:{' '}
                                <Typography
                                    component="span"
                                    variant="body_500"
                                    color="text.secondary"
                                >
                                    {navState?.itemData?.isinCode ?? ''}
                                </Typography>
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                {isLoading ? (
                    <Skeleton variant="text" animation="wave" width={100} />
                ) :
                    <IconButton
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px'
                        }}
                        onClick={() => handleDeleteCardValue(folio?.id ?? "", values?.fund?.[id]?.selectedSchemeDetails?.uniqueId ?? "")}
                        disabled={isSubmitting}
                    >
                        <DeleteIcons />
                        <Hidden only={'xs'}>
                            <Typography variant="body_500" color={palette.error[500]}>
                                Remove
                            </Typography>
                        </Hidden>
                    </IconButton>
                }
            </Box>
            <Grid container rowGap={{ xs: '5px', sm: '10px', md: '15px', lg: '20px' }}>

                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400' color={palette.text.secondary}>Folio</Typography>}
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500' fontWeight={600} color={palette.text.primary}>{itemData.folioNo}</Typography>}
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400' color={palette.text.secondary}>{itemData.navDate || "NAV: -"}</Typography>}
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500' fontWeight={600} color={palette.text.primary}>{formatCurrency({ value: itemData.navValue, locale, currencyCode })}</Typography>}
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400' color={palette.text.secondary}>Balance Unit</Typography>}
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500' fontWeight={600} color={palette.text.primary}>{itemData?.units ?? 0}</Typography>}
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400' color={palette.text.secondary}>Balance Amount</Typography>}
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500' fontWeight={600} color={palette.text.primary}>{formatCurrency({ value: itemData?.balanceAmount, locale, currencyCode })}</Typography>}
                </Grid>
                <Grid item lg={3} md={6} sm={6} xs={12} sx={{
                    justifyContent: 'space-between',
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'column', md: 'column', lg: 'column' },
                }} >
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> :
                        <>
                            <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='subtitle_400' color={palette.text.secondary}>
                                Free Units
                                <Tooltip
                                    slotProps={{
                                        tooltip: {
                                            sx: {
                                                margin: "0px !important",
                                                backgroundColor: "transparent"
                                            }
                                        }
                                    }}
                                    title={
                                        <div
                                            style={{
                                                borderRadius: '10px', backgroundColor: '#0F131F', padding: '15px'
                                            }}
                                        >
                                            <span
                                                style={{
                                                    color: palette.primary[500],
                                                    fontWeight: '600',
                                                    fontSize: '16px'
                                                }}
                                            >
                                                Free units

                                            </span>
                                            <br />
                                            <span style={{ ...typography.subtitle_500, fontFamily: typography.fontFamily }}>Units that are not in Lock-in.</span>
                                        </div>
                                    }
                                >
                                    <IconButton>
                                        <InfoIconOutlined />
                                    </IconButton>
                                </Tooltip>
                            </Typography>
                        </>
                    }
                    {isLoading ? <Skeleton variant='text' animation="wave" width={100} /> : <Typography fontSize={{ xs: '14px', sm: '14px', md: '16px', lg: '16px' }} variant='body_500' fontWeight={600} color={palette.text.primary}>{itemData?.availableUnits}</Typography>}
                </Grid>
            </Grid>
            <Divider />
            <Typography variant='h2' fontSize={{ xs: '14px', sm: '16px', md: '18px', lg: '18px' }}>Redeem Details</Typography>
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <CustomeBlueDropDown
                        isLoading={isLoading}
                        disabled={isSubmitting || values?.fund[id]?.entireBalance}
                        // name='redeemValue'
                        name={`fund[${id}].redeemValue`}
                        label='Redeem Type'
                        list={[{ value: 'amount', label: 'Amount' }, { value: 'units', label: 'Units' }]}
                        boxStyle={{
                            borderTopRightRadius: '0px',
                            borderBottomRightRadius: '0px',
                            borderRight: `1px solid ${palette.text.secondary}b2`
                        }}
                        onChange={async (event, value) => {
                            await setFieldValue(`fund[${id}].redeemValue`, event.target.value);
                            await setFieldValue(`fund[${id}].installment`, '');
                            // await validateField(`fund[${id}].installment`)

                            if (event.target.value === 'amount') {
                                await setFieldValue(`fund[${id}].entireBalance`, false)
                            }
                        }}
                    />
                    <FormCheckBox
                        name={`fund[${id}].entireBalance`}
                        isLoading={isLoading}
                        disabled={isSubmitting}
                        onChange={async (event, value) => {
                            setFieldValue(`fund[${id}].entireBalance`, value);
                            if (value) {
                                await setFieldValue(`fund[${id}].installment`, itemData?.availableUnits)
                                await setFieldValue(`fund[${id}].redeemValue`, 'units')
                                // setFieldValue(`fund[${id}].installment`, values.fund[id].redeemValue === "amount" ? Math.round(itemData?.availableUnits * itemData?.navValue) : itemData?.availableUnits)
                            }
                        }} />
                    {/* {values.fund[id].redeemValue === 'units' &&
                        <FormCheckBox
                            name={`fund[${id}].entireBalance`}
                            isLoading={isLoading}
                            disabled={isSubmitting}
                            onChange={(event, value) => {
                                setFieldValue(`fund[${id}].entireBalance`, value);
                                if (value) {
                                    setFieldValue(`fund[${id}].installment`, values.fund[id].redeemValue === "amount" ? Math.round(itemData?.availableUnits * itemData?.navValue) : itemData?.availableUnits)
                                }
                            }} />
                    } */}
                </Grid>
                <Grid item xs={12} lg={6}>
                    <CustomeNumberInput
                        name={`fund[${id}].installment`}
                        label=''
                        removeIcons={values.fund[id].redeemValue === 'units'}
                        minlabel={`${values.fund[id].redeemValue === "amount" ?
                            `Min: ${String.fromCharCode(parseInt(currencySymbol, 16))} ${Number(filterValidation?.minimumInstallmentAmount ?? 0)}` :
                            `Max: ${itemData?.availableUnits ?? 0}`}`}
                        isLoading={isLoading}
                        disable={values.fund[id].entireBalance || isSubmitting}
                        textType='number'
                        boxStyle={{
                            borderTopLeftRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            marginTop: '3px',
                        }}
                        warningText={values.fund[id].redeemValue === 'amount' ? "amount" : 'units'}
                    />
                </Grid>
                <Grid item xs={12} lg={6} mt={2}>
                    <CustomeBlueDropDown
                        disabled={isSubmitting}
                        isLoading={isLoading}
                        name={`fund[${id}].bankType`}
                        list={[...bankList].map((item) => ({ value: item?.bankAccountNumber, label: `${item?.bankName}-${item?.bankAccountNumber}` }))} 
                    />
                </Grid>

                <Grid item xs={12} lg={12}>
                    <Typography variant="subtitle_600" mt={2}>
                        <i>Note : {REDEEM_TO_DEFAULT_ACCOUNT}</i>
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Card